// Mengenali build yang sedang berjalan, lalu memulihkan tab lama setelah deploy.
//
// Tidak ada efek samping saat modul ini diimpor: semua sentuhan DOM ada di dalam fungsi,
// supaya appVersion.check.mjs bisa menguji bagian murninya di Node.

// Hash pada nama entry script SUDAH menjadi sidik jari build, jadi tak perlu menyuntik
// apa pun lewat config webpack/Vite. Mencakup dua bentuk sekaligus:
//   webpack (customer)            /js/app.e6b02b98.js
//   Vite (agent-office/superadmin) /assets/index-C27L9NTs.js
// Nama tanpa hash milik dev server sengaja TIDAK cocok; hasilnya "" dan seluruh mekanisme
// di berkas ini mati sendiri saat npm run serve.
export const ENTRY_RE = /\/(?:js\/app|assets\/index)[.-][A-Za-z0-9_-]+\.js/;

export const entryOf = (html) => (String(html).match(ENTRY_RE) || [""])[0];

// Pesan "chunk gagal dimuat", lintas bundler dan browser.
export const isChunkError = (msg) =>
    /Loading( CSS)? chunk|dynamically imported module|Importing a module script failed/i.test(
        String(msg || "")
    );

// Ketiga app membuang console.* di build produksi (drop_console di terser). Label build
// justru HARUS tetap terbaca di sana, karena console adalah satu-satunya tempat ia muncul:
// tidak ada di UI. Terser hanya mengenali pemanggilan yang diawali identifier `console`,
// jadi satu pintu ini lolos tanpa menghidupkan kembali console.log lama yang memang
// sengaja dibungkam. Diverifikasi langsung ke terser, bukan diasumsikan.
const catat = (pesan) => window.console && window.console.info(pesan);

let berjalan = null;
let adaBuildBaru = false;

export function currentBuild() {
    if (berjalan === null) {
        berjalan = entryOf(
            Array.from(document.querySelectorAll("script[src]"))
                .map((s) => s.getAttribute("src"))
                .join(" ")
        );
    }
    return berjalan;
}

export const hasNewBuild = () => adaBuildBaru;

// ponytail: rem waktu, bukan sekali-seumur-sesi. Sekali-seumur-sesi membuat deploy KEDUA
// dalam satu sesi tak tertolong; tanpa rem sama sekali, chunk yang hilang permanen (bukan
// karena deploy) berubah jadi loop reload.
export function reloadTo(target) {
    try {
        const last = Number(sessionStorage.getItem("buildReloadAt") || 0);
        if (Date.now() - last < 10000) return false;
        sessionStorage.setItem("buildReloadAt", String(Date.now()));
    } catch (e) {
        // Safari mode privat melempar saat menulis sessionStorage. Tanpa rem pun reload masih
        // lebih baik daripada layar yang diam, jadi diteruskan.
    }
    window.location.assign(target);
    return true;
}

async function cek() {
    if (adaBuildBaru || document.visibilityState !== "visible" || !currentBuild()) return;
    try {
        const res = await fetch("/index.html", { cache: "no-store" });
        if (!res.ok) return;
        const live = entryOf(await res.text());
        if (live && live !== currentBuild()) {
            adaBuildBaru = true;
            catat(
                `[build] server sudah ${live}, yang berjalan ${currentBuild()}; dimuat ulang saat pindah halaman`
            );
        }
    } catch (e) {
        // Offline, atau index.html tak terbaca. Diamkan; dicoba lagi saat tab terlihat berikutnya.
    }
}

export function watchForNewBuild(label) {
    catat(`${label} build ${currentBuild() || "dev"}`);
    if (!currentBuild()) return; // dev server: tak ada hash, tak ada yang perlu diawasi
    document.addEventListener("visibilitychange", cek);
    // agent-office & superadmin membungkus route dengan defineAsyncComponent, jadi kegagalan
    // import TIDAK sampai ke router.onError. Event Vite ini pintu resminya. Di webpack ia
    // tak pernah menyala, jadi aman dipasang di ketiga app.
    window.addEventListener("vite:preloadError", () => reloadTo(window.location.href));
}
